import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
    };
  },
  async getActiveMessages() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/ActiveMessages`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
